import React from 'react'
import {Distance, Elevation} from 'common/units'
import moment from 'moment'
import {urls} from 'lib/urls'
import {RouteThumb} from 'common/ListItems'
import {HighlightedPhoto} from 'common/ListItems/HighlightedPhoto'
import {Icon} from 'common/Icon'
import {CoreLink} from 'common/CoreLink'
import cx from 'classnames'
import styles from './RouteCondensedStats.scss'
import {DELETE_TROUTE_DIALOG} from 'common/dialogs/DeleteTRoute'
import {j} from 'lib/textUtils'
import {readDateFormatFromPreferences} from 'lib/dateUtils'
import {MobileCollapse} from 'common/layouts/SideNavLayout/SideNavContexts'
import {RichListItemDetail as Detail} from 'common/styleguide/RichListItem'

export class RouteCondensedStats extends React.PureComponent {
  onArrowClick = () => this.props.toggleItem(this.props.expandKey)

  render () {
    const {
      troute: route,
      expanded,
      expandKey,
      showDialog,
      currentUser,
      pinned,
      pin,
      unpin,
      newName, // TODO remove once troutes come from redux
      checkbox
    } = this.props
    const isExpanded = expanded.has(expandKey)

    const nameToShow = newName || route.name // TODO remove once troutes come from redux

    return (
      <div className={cx(styles.RouteCondensedStats, isExpanded && styles.isExpanded)}>
        <Grid className={styles.mainGrid}>
          <MobileCollapse>{checkbox}</MobileCollapse>
          <Col className={styles.nameAndLocationCol} flex='7'>
            <h4><CoreLink to={urls.routes.show(route.id)} title={nameToShow}>{nameToShow}</CoreLink></h4>
            <div className={styles.location}>
              <span data-tip title='Start Location'>
                {j([route.locality, route.administrativeArea])}
              </span>
            </div>
          </Col>
          <MobileCollapse>
            <Col flex='0 0 16px' marginTop='0'>
              {route.hasCoursePoints && <Detail data-tip title='Has Cuesheet'>
                <Icon i='md-document' />
              </Detail>}
            </Col>
          </MobileCollapse>
          <Col className={styles.rideStatsCol} flex={3 * 6}>
            <RouteStats route={route} currentUser={currentUser} />
          </Col>
          <Col className={styles.actionsCol} flex='0 0 auto' alignRight>
            <div className={styles.actionsIcons}>
              <a href={`/routes/${route.id}/edit`}>
                <Icon
                  className={styles.actionsIcon}
                  data-tip
                  title='Edit'
                  i='md-create'
                  size={20} />
              </a>
              <Icon
                onClick={() => pinned(route.id) ? unpin('route', route.id) : pin('route', route.id)}
                data-tip
                title={pinned(route.id) ? 'Unpin' : 'Pin'}
                i='pin'
                size={20}
                className={cx(styles.actionsIcon, pinned(route.id) && styles.pinned)} />
              <Icon
                onClick={() => showDialog(DELETE_TROUTE_DIALOG)}
                data-tip
                title='Delete'
                i='md-trash'
                size={20}
                className={styles.actionsIcon} />
            </div>
          </Col>
          <Col className={styles.thumbnailsCol} flex='0 0 92px' alignRight>
            <HighlightedPhoto photoId={route.highlightedPhotoId} parentType={'route'} parentId={route.id} readonly={false} style={{height: '40px', width: '40px'}} />
            <RouteThumb size={40} route={route} />
          </Col>
          <MobileCollapse>
            <Col className={styles.expandIconCol} flex='0 0 auto' alignRight>
              <div className={styles.expandClickTarget} onClick={this.onArrowClick}>
                <Icon i={'ios-arrow-down'} size={22} className={cx(styles.expandIcon, isExpanded && styles.expanded)} />
              </div>
            </Col>
          </MobileCollapse>
        </Grid>
      </div>
    )
  }
}

const RouteStats = ({route, currentUser}) => {
  const createdAt = moment(route.createdAt)
  const updatedAt = moment(route.updatedAt)
  const showUpdatedAt = updatedAt.diff(createdAt, 'days') >= 1

  return (
    <div className={styles.RouteStats}>
      <Grid className={styles.statGrid}>
        <Col>
          <span data-tip title='Distance'>
            <Distance short value={route.distance} />
          </span>
        </Col>
        <Col>
          <span data-tip title='Elevation Gain'>
            <Elevation short value={route.elevationGain} />
          </span>
        </Col>
        <Col>
          {route.visibility === 0 && 'Public'}
          {route.visibility === 1 && 'Private'}
          {route.visibility === 2 && 'Friends Only'}
        </Col>
      </Grid>
      <Grid className={styles.dateGrid}>
        <Col className={styles.dateCol} flex='1 0 0%'>
          {createdAt.format(readDateFormatFromPreferences())}
          {showUpdatedAt && <div className={styles.updatedAt}>
            Updated {updatedAt.format(readDateFormatFromPreferences())}
          </div>}
        </Col>
      </Grid>
    </div>
  )
}

const Grid = ({className, children}) => (
  <div className={cx(styles.Grid, className)}>
    {children}
  </div>
)

const Col = ({children, className, flex, alignRight, marginTop}) => {
  const margin = `${marginTop} 0 0 0` || ''
  return <div className={cx(styles.Col, className, alignRight && styles.alignRight)} style={{flex: flex, margin: margin}}>
    {children}
  </div>
}
